export const setDynamicTableFilterYear = year => {
  return {
    type: "SET_DYNAMIC_TABLE_FILTER_YEAR",
    year
  };
};

export const setDynamicTableSearchWord = searchWord => {
  return {
    type: "SET_DYNAMIC_TABLE_SEARCH_WORD",
    searchWord
  };
};

export const setDynamicTableSortBy = sortBy => ({
  type: "SET_DYNAMIC_TABLE_SORT_BY",
  sortBy
});

export const setDynamicTableCollaboratorRole = selected => ({
  type: "SET_DYNAMIC_TABLE_COLLABORATOR_ROLE",
  selected
});

export const setDynamicTableCollaboratorAttribution = selected => ({
  type: "SET_DYNAMIC_TABLE_COLLABORATOR_ATTRIBUTION",
  selected
});

export const setBudgetStateConfig = payload => ({
  type: "SET_BUDGET_STATE_CONFIG",
  payload
});

export const setBudgetState = selected => ({
  type: "SET_BUDGET_STATE",
  selected
});

export const initDynamicTableData = () => {
  return {
    type: "INIT_DYNAMIC_TABLE_DATA"
  };
};

export const setPageSizeState = pageSize => {
  console.log("pageSize==", pageSize);
  return {
    type: "SET_PAGE_SIZE_STATE",
    pageSize
  };
};

export const setStartPageState = startPage => {
  return {
    type: "SET_START_PAGE_STATE",
    startPage
  };
};

export const setDynamicTableData = data => {
  return {
    type: "SET_DYNAMIC_TABLE_DATA",
    payload: data
  };
};

export const fetchDynamicTableData = data => ({
  type: "FETCH_DYNAMIC_TABLE_DATA",
  payload: data
});

export const updateDynamicTableData = (rowIndex, data) => {
  return {
    type: "UPDATE_DYNAMIC_TABLE_DATA",
    payload: { rowIndex, data }
  };
};

export const updateBudgetParts = data => ({
  type: "UPDATE_BUDGET_PARTS",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/dynamic-table.js